export default {
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};
